// =============================================================================
// Settings — Dirty-state tracking
// =============================================================================
// Permette ai singoli tab di segnalare se hanno modifiche non salvate, così la
// SettingsPage può avvisare l'utente prima di cambiare tab o chiudere la pagina.
// =============================================================================

import { createContext, useContext, useEffect } from 'react';

interface SettingsDirtyContextValue {
  /** Registra/aggiorna lo stato "dirty" del tab indicato. */
  register: (id: string, dirty: boolean) => void;
}

export const SettingsDirtyContext = createContext<SettingsDirtyContextValue | null>(null);

/**
 * Hook usato dai tab con form inline per dichiarare se hanno modifiche pendenti.
 * Si auto-pulisce allo smontaggio del tab.
 */
export function useReportDirty(id: string, dirty: boolean) {
  const ctx = useContext(SettingsDirtyContext);
  useEffect(() => {
    ctx?.register(id, dirty);
    return () => ctx?.register(id, false);
  }, [ctx, id, dirty]);
}
